import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { InventoryManagerListItem } from "../../inventory.types";
import { requestUpdateManagerStatus } from "./updateManagerStatus.request";

const useUpdateManagerStatus = (
  options?: MutationOptions<InventoryManagerListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateManagerStatus,
    ...options
  });
};

export default useUpdateManagerStatus;
